import { z } from 'zod'

import { barrierTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/barrier-type.schema'
import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'

export const vanillaStructuredSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('vanilla-structured'),

  participation_rate: z.number(),
  contract_type: contractTypeSchema,
  barrier_type: barrierTypeSchema,

  knockdown_input_level: z.number(),
})

export type VanillaStructuredSchemaType = z.infer<typeof vanillaStructuredSchema>
